<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
        <el-col :span="24">
          <el-form-item label="选择归属上级" prop="pid">
            <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
        </el-col>
             <el-col :span="24">
          <el-form-item label="选择类型等级" prop="type">
            <el-radio-group v-model="form_data.level">
              <el-radio :label="1">一级</el-radio>
              <el-radio :label="2">二级</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        

        <el-col :span="24">
          <el-form-item label="场所类型名称" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="场所类型缩写" prop="abbreviation">
           <el-input v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
           <el-col :span="24">
          <el-form-item label="状态" prop="state">
            <el-switch v-model="form_data.state" :active-value="0" :inactive-value="1"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>


export default {
  name: 'l-place-type-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
    place_type_list(){
      return this.$store.state.list.place_type_list
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中

      //是否显示
      tree_node: [

      ],
      //表单数据
      form_data: {
        is_node:"",
        pid:0,
        name: '',
        abbreviation:'',
        state:0,
      },
      //表单验证规则
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'change' }
        ],
        abbreviation: [
          { required: true, message: '缩写不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    //获取数据
    getData() {
        this.$_invoke(`placeType_getData`, ).then((ret) => {
                this.tree_node = ret.tree_node;
              }).finally(() => {
                this.loading = false;
              });
              
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`placeType_updateData`, { id: this.$props.id }).then((ret) => {
          this.form_data = ret.data;
          this.tree_node = ret.tree_node;
        }).finally(() => {
          this.loading = false;
        });

      } else {
        // this.tree_node = ret.tree_node;
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {//添加
            this.$_invoke('placeType_save', this.form_data).then(() => {
              this.$_msg.success('添加成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            this.$_invoke(`placeType_update`, {
              id: this.$props.id,
              ...this.form_data
            }).then(() => {
              this.$_msg.success('修改成功');
              this.$emit('on-success');
            }).finally(() => {
              this.submitting = false;
            })
          }
        }
      })

    },
  },
}
</script>